import { fetch } from '@atlassian/eoc-fetch';

import { type RequestedResponder, type ResponderNamesResponse } from '../../common/types';

export const getResponderNames = (requestedResponders: RequestedResponder[]) => {
	const responders = requestedResponders.reduce<RequestedResponder[]>((acc, curr) => {
		// any is intentional here we don't want to add
		// unknown to the ResponderType because we don't want it to be public
		if (curr.type === ('unknown' as any)) {
			return [
				...acc,
				{ id: curr.id, type: 'schedule' },
				{ id: curr.id, type: 'user' },
				{ id: curr.id, type: 'team' },
				{ id: curr.id, type: 'escalation' },
			];
		}
		return [...acc, curr];
	}, []);
	return fetch<ResponderNamesResponse>(`/v1/alerts/responders/names`, {
		method: 'POST',

		body: {
			responders,
		},
	});
};
